import { Body, Controller, Post } from '@nestjs/common';
import {FactoryResponseModel} from '../../../../../libs/shared-models/src/common/factory/factory-response-objects'
import {ApplicationExceptionHandler} from "packages/libs/backend-utils/src/"
import { SIzeMatrixFabricBDto } from './dto/size-matrix-dto';
import { ApiBody } from '@nestjs/swagger';
import { SizeMatrixActivateDeactivateDto, SizeMatrixResponseModel } from '@project-management-system/shared-models';
import { SizeMatrixService } from './size-matrix-service';

@Controller('/size-matrix-fabric-code')
export class SizeMatrixController {
    constructor(
         private Service: SizeMatrixService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler
        ) { }




@ApiBody({ type: SIzeMatrixFabricBDto })
@Post('/createSizeMatrix')
async createSizeMatrix(@Body() req: any): Promise<SizeMatrixResponseModel> {
  try {
    return await this.Service.createSizeMatrix(req,false)
  } catch(error) {
    return this.applicationExceptionhandler.returnException(SizeMatrixResponseModel,error)
  }
}

@ApiBody({ type: SIzeMatrixFabricBDto })
@Post('/updateSizeMatrix')
async updateSizeMatrix(@Body() req: any): Promise<SizeMatrixResponseModel> {
  try {
    return await this.Service.createSizeMatrix(req,true)
  } catch(error) {
    return this.applicationExceptionhandler.returnException(SizeMatrixResponseModel,error)
  }
}

//    @Post('/getStylesData')
//     async getStylesData(): Promise<StylesResponseModel>{
//         try{
//             return await this.Service.getStylesData()
//         }catch(error){
//             return this.applicationExceptionhandler.returnException(StylesResponseModel, error)
//         }
//     }

//     @Post('/getActiveStyles')
//     async getActiveStyles() : Promise<StylesResponseModel>{
//         try{
//             return await this.Service.getActiveStyles()
//         }catch(error){
//             return this.applicationExceptionhandler.returnException(StylesResponseModel, error);
//         }
//     }

   @Post("/activateOrDeactivate")
   @ApiBody({ type: SizeMatrixActivateDeactivateDto })
   async activateOrDeactivate(@Body() req:any) : Promise<SizeMatrixResponseModel>{
    try{
        await this.Service.activateOrDeactivate(req)
    }catch(error){
        return this.applicationExceptionhandler.returnException(SizeMatrixResponseModel,error)
    }
  }


  
}
